/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { PostPaymentRequestsBankAccountRequestTransferFeeCondition } from './post-payment-requests-bank-account-request-transfer-fee-condition';

/**
 * 
 * @export
 * @interface PostPaymentRequestsBankAccountRequest
 */
export interface PostPaymentRequestsBankAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'accountType': PostPaymentRequestsBankAccountRequestAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'companyCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'companyName': string;
    /**
     * 
     * @type {PostPaymentRequestsBankAccountRequestTransferFeeCondition}
     * @memberof PostPaymentRequestsBankAccountRequest
     */
    'transferFeeCondition': PostPaymentRequestsBankAccountRequestTransferFeeCondition;
}

export const PostPaymentRequestsBankAccountRequestAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type PostPaymentRequestsBankAccountRequestAccountTypeEnum = typeof PostPaymentRequestsBankAccountRequestAccountTypeEnum[keyof typeof PostPaymentRequestsBankAccountRequestAccountTypeEnum];


